module.exports = "/images/play-f.svg?c88480ef5a62454be9b99319faf8dd98";